import React, { useState } from "react";
import { svg } from "../../../resources/Svg";
import DeleteRecord from "../Modals/DeleteRecord";
import EditRecord from "../Modals/EditRecord";

const RecentActivityList = ({
  date,
  todayExpense,
  todayRevenue,
  id,
  margin,
  description,
  userInfo,
}) => {
  const [isEditRecordOpen, setIsEditRecordOpen] = useState(false);
  const [isDeleteRecordOpen, setIsDeleteRecordOpen] = useState(false);

  const formatNumber = (num) => {
    if (num === null) return num;
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  };

  const formatDate = (date) =>
    ("0" + date.getDate()).slice(-2) +
    "-" +
    ("0" + (date.getMonth() + 1)).slice(-2) +
    "-" +
    date.getFullYear();

  return (
    <>
      <tr className="hover:bg-blue-50">
        <td className="px-6 py-4 whitespace-nowrap">
          <div className="flex items-center">
            <div className="flex-shrink-0 h-10 w-10">
              <div className="h-10 w-10 rounded-full cursor-pointer text-gray-700">
                {svg.money}
              </div>
            </div>
            <div className="ml-4">
              <div className="text-sm font-medium text-gray-900">
                {formatDate(date)}
              </div>
            </div>
          </div>
        </td>
        <td className="px-6 py-4 whitespace-nowrap">
          <div className="text-sm text-gray-900 ">{description}</div>
        </td>

        {!userInfo?.isSalary && (
          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
            {formatNumber(todayRevenue)}
          </td>
        )}

        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
          {formatNumber(todayExpense)}
        </td>
        <td className="px-6 py-4 whitespace-nowrap">
          {margin >= 0 ? (
            <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
              Positive
            </span>
          ) : (
            <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
              Negative
            </span>
          )}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
          {formatNumber(margin)}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
          <div className="flex items-center space-x-2">
            <div
              className="text-blue-600 hover:text-blue-900 cursor-pointer w-5 h-5"
              onClick={() => setIsEditRecordOpen(true)}
            >
              {svg.edit}
            </div>
            <div
              className="text-red-600 hover:text-red-500 cursor-pointer w-5 h-5"
              onClick={() => setIsDeleteRecordOpen(true)}
            >
              {svg.delete}
            </div>
          </div>
        </td>
      </tr>

      {isEditRecordOpen &&
        (userInfo?.isSalary ? (
          <EditRecord
            open={isEditRecordOpen}
            setOpen={setIsEditRecordOpen}
            id={id}
            _date={date}
            _desc={description}
            _todayExpense={todayExpense}
          />
        ) : (
          <EditRecord
            open={isEditRecordOpen}
            setOpen={setIsEditRecordOpen}
            id={id}
            _date={date}
            _desc={description}
            _todayExpense={todayExpense}
            _todayRevenue={todayRevenue}
          />
        ))}

      {isDeleteRecordOpen && (
        <DeleteRecord
          open={isDeleteRecordOpen}
          setOpen={setIsDeleteRecordOpen}
          id={id}
        />
      )}
    </>
  );
};

export default RecentActivityList;
